module.exports = __webpack_public_path__ + "static/media/Dt9.f8899ad6.jpg";